import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Api } from "../../utils/api";

class EstablishmentsListTable extends React.Component {
  constructor() {
    super();
    this.api = new Api();
    this.goTo = this.goTo.bind(this);
  }

  state = {
    establishmentsList: null,
  };

  componentDidMount() {}

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  render() {
    const { establishments } = this.props;

    return (
      <div className="main-reqlist-container">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" width="600px">
                  Nome do Equipamento
                </TableCell>
                <TableCell align="left" width="200px">
                  Valência
                </TableCell>
                <TableCell align="left" width="400px">
                  Entidade
                </TableCell>
                <TableCell align="left">Distrito</TableCell>
                <TableCell align="left">Concelho</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {establishments &&
                establishments.map((establishment) => (
                  <TableRow
                    key={establishment.establishment_id}
                    className="hand"
                    onClick={() =>
                      this.goTo(
                        `/establishments/${establishment.establishment_id}`
                      )
                    }
                  >
                    <TableCell align="left">{establishment.name}</TableCell>
                    <TableCell align="left">{establishment.valence}</TableCell>
                    <TableCell align="left">
                      {establishment.entity_name}
                    </TableCell>
                    <TableCell align="left">
                      {establishment.district_name}
                    </TableCell>
                    <TableCell align="left">
                      {establishment.county_name}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
});

EstablishmentsListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EstablishmentsListTable));
